export default __webpack_public_path__ + "static/media/notification_alert.3fa860de.svg";